export default {
    data: () => ({
        searchText: null
    }),

    methods: {
        submitSearch() {
            if (this.searchText != null) {
                window.location.href = route('nl.activities', { 'search': this.searchText });
            }
        }
    }
}